import { render, staticRenderFns } from "./DiscountProducts.vue?vue&type=template&id=d6e170e4"
import script from "./DiscountProducts.vue?vue&type=script&lang=js"
export * from "./DiscountProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports